module.exports = __webpack_public_path__ + "static/media/history_9.e2529ee5.jpg";